export default "__VITE_ASSET__CJagtd9y__"